
module.exports = function getResource(label, vars = []) {
    let resources = {
        filterBy: 'Filter by'
    };
    return resources[label];
};
